export default __webpack_public_path__ + "static/contact-b151934c02c2fdf0e8bd4fab6a9fcd5f.gif";